import { Row, Col, Card, Table, Select, Divider } from "antd";
import { useEffect, useContext, useState } from "react";
import dayjs from "dayjs/esm";

import { Context } from "../../context";
import { Fetch } from "../../fetch";

import "./styles.css";
import Column from "antd/lib/table/Column";

const { Option } = Select;

const ConvertedSubscriptions = () => {
  const { apiUrl, token } = useContext(Context);
  const [data, setData] = useState([]);
  const [year, setYear] = useState(dayjs().year());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    Fetch(
      `${apiUrl}/reports/subscribers_conversion?financial_year=${year}`,
      token,
      (result) => {
        setData(result.data);
        setLoading(false);
      }
    );
  }, [apiUrl, token, year]);

  return (
    <div>
      <Card>
        <Row>
          <Col span={20}>
            <h2>User Conversion</h2>
          </Col>
          <Col span={4}>
            <Select
              style={{ width: "100%" }}
              defaultValue={year}
              onChange={setYear}
            >
              <Option value={year - 4}>{year - 4}</Option>
              <Option value={year - 3}>{year - 3}</Option>
              <Option value={year - 2}>{year - 2}</Option>
              <Option value={year - 1}>{year - 1}</Option>
              <Option value={year}>{year}</Option>
              <Option value={year + 1}>{year + 1}</Option>
              <Option value={year + 2}>{year + 2}</Option>
              <Option value={year + 3}>{year + 3}</Option>
              <Option value={year + 4}>{year + 4}</Option>
              <Option value={year + 5}>{year + 5}</Option>
            </Select>
          </Col>
        </Row>
        <Divider style={{ marginTop: "0px" }} />
        <Table
          style={{ margin: "1%" }}
          dataSource={data}
          size="small"
          pagination={false}
          loading={loading}
        >
          <Column title="Month" align="center" dataIndex={"month"} />
          <Column
            title="Registered Users"
            align="center"
            dataIndex={"registered_users"}
          />
          <Column
            title="Subscribed Users"
            align="center"
            dataIndex={"subscribed_users"}
          />
          <Column
            title="Conversion Rate"
            align="center"
            dataIndex={"conversion_rate"}
            render={(_, record) => `${record.conversion_rate} %`}
          />
        </Table>
      </Card>
    </div>
  );
};

export default ConvertedSubscriptions;
